import { render, staticRenderFns } from "./ConfigAlertDiscord.vue?vue&type=template&id=01945986&scoped=true"
import script from "./ConfigAlertDiscord.vue?vue&type=script&lang=js"
export * from "./ConfigAlertDiscord.vue?vue&type=script&lang=js"
import style0 from "./ConfigAlertDiscord.vue?vue&type=style&index=0&id=01945986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01945986",
  null
  
)

export default component.exports